import { useState } from 'react';
import WizardCard from './WizardCard.jsx';

export default function StepBedTime({ value, onChange, onBack, onNext }) {
  const [local, setLocal] = useState(value || '');

  function handleNext() {
    if (local) onChange(local);
    onNext();
  }

  return (
    <WizardCard
      step={4}
      title="What time did you go to bed last night?"
      subtitle="No judgment — just tracking."
      onBack={onBack}
      onNext={handleNext}
      nextDisabled={!local}
    >
      <input
        type="time"
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        className="w-full px-4 py-3 bg-bg-input border border-border-base rounded text-text-primary text-lg focus:outline-none focus:border-accent-blue"
      />
    </WizardCard>
  );
}
